module.exports = __webpack_public_path__ + "static/media/home@3x.f39ef7c3.png";